export default __webpack_public_path__ + "assets/images/bed.2efe5f77adb845f5712e30a2154bf970.webp";